module.exports = __webpack_public_path__ + "static/img/Send12.e5ced55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send12.png
// module id = joqb
// module chunks = 0